import { render, staticRenderFns } from "./create_update_ar.vue?vue&type=template&id=647f774d"
import script from "../../logic/l_create_update_ar.js?vue&type=script&lang=js&external"
export * from "../../logic/l_create_update_ar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports